__turbopack_context__.v({
  "action": "actions-module-scss-module__EKadiW__action",
});
